// Ad-block detection — independent of consent and of any tracker.
//
// Why: the game's pre-init used the absence of the AppsFlyer id (afUserId) as an
// "ad blocker detected" signal and blocked the game. Once AppsFlyer only loads
// after consent, that signal no longer works — a user who simply declined
// cookies would look identical to one with an ad blocker. This detector decides
// ad-block presence WITHOUT loading any tracker or reading/writing storage, so
// it needs no consent. The game then blocks only genuine ad-block users; users
// who declined cookies (no blocker) can still play, just without attribution.
//
// Two local, privacy-clean baits (first conclusive signal wins):
//   1. Cosmetic bait — ad blockers hide elements with ad-like classes.
//   2. Network bait — a local script whose path matches ad-block filter lists.

/** Resolves true if an ad blocker is detected. Never rejects. */
export function detectAdblock() {
  return new Promise((resolve) => {
    if (typeof document === "undefined") {
      resolve(false);
      return;
    }
    let done = false;
    const finish = (blocked) => {
      if (done) return;
      done = true;
      resolve(blocked);
    };

    // 1) Cosmetic bait: elements with ad-like classes get hidden by cosmetic filters.
    try {
      const bait = document.createElement("div");
      bait.className = "adsbox ad-banner ads ad pub_300x250";
      bait.style.cssText = "position:absolute;left:-9999px;top:-9999px;height:10px;width:10px;";
      document.body.appendChild(bait);
      window.requestAnimationFrame(() => {
        const hidden =
          bait.offsetParent === null ||
          bait.clientHeight === 0 ||
          window.getComputedStyle(bait).display === "none";
        bait.remove();
        if (hidden) finish(true); // only conclude on a positive; let the network bait rule out
      });
    } catch (_) {
      /* ignore */
    }

    // 2) Network bait: a local file named to match filter lists; blocked → onerror.
    try {
      const s = document.createElement("script");
      s.src = "/js/ads.js?_=" + Date.now();
      s.onload = () => {
        s.remove();
        finish(false);
      };
      s.onerror = () => {
        s.remove();
        finish(true);
      };
      document.head.appendChild(s);
    } catch (_) {
      /* ignore */
    }

    // Fallback: if nothing is conclusive, assume no ad blocker (never lock users out).
    setTimeout(() => finish(false), 2000);
  });
}
